
  import { Component, Prop, Vue, Watch } from "vue-property-decorator";
  import LzButton from "@/components/Button.vue";
  import LzBox from "@/components/Box.vue";
  import LzModal from "@/components/Modal.vue";
  import LzStepper from "@/components/Stepper.vue";
  import LzSubscription from "@/components/Subscription.vue";
  import { namespace } from "vuex-class";
  import { apiOrganizations } from "../api";
  import LzPaymentGateway from "./PaymentGateway.vue";

  const store = namespace("organization");
  const auth = namespace("auth");

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  declare const ZFWidget: any;

  Component.registerHooks(["beforeRouteLeave"]);

  @Component({
    components: {
      LzButton,
      LzStepper,
      LzBox,
      LzPaymentGateway,
      LzModal,
      LzSubscription
    }
  })
  export default class Read extends Vue {
    @store.Action
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public updatePlan!: (planId: string) => void;

    loaded = false;

    @auth.State("id")
    public ongId!: string;

    @auth.State("blockedBySubscriptionPlan")
    public blockedBySubscriptionPlan!: boolean;

    @store.State("planId")
    public planId!: string;

    @Prop({ default: "general" })
    step!: string;

    active = window.location.search.trim() ? "paymentGateway" : this.step;
    showBlockedModal = false;

    categoryOptions = {
      children: this.$t(
        "organization.read.generalForm.sector.options.children"
      ),
      education: this.$t(
        "organization.read.generalForm.sector.options.education"
      ),
      health: this.$t("organization.read.generalForm.sector.options.health"),
      animals: this.$t("organization.read.generalForm.sector.options.animals"),
      environment: this.$t(
        "organization.read.generalForm.sector.options.environment"
      ),
      naturalDisaster: this.$t(
        "organization.read.generalForm.sector.options.naturalDisaster"
      ),
      economicDev: this.$t(
        "organization.read.generalForm.sector.options.economicDev"
      ),
      other: this.$t("organization.read.generalForm.sector.options.other")
    };

    typeOptions = {
      ong: this.$t("organization.read.generalForm.orgType.options.ong"),
      fundation: this.$t(
        "organization.read.generalForm.orgType.options.foundation"
      ),
      company: this.$t("organization.read.generalForm.orgType.options.company"),
      other: this.$t("organization.read.generalForm.orgType.options.other")
    };

    payMethodOptions = {
      card: this.$t("organization.read.subscriptionForm.payMethod.options.card")
    };

    // generalForm
    generalForm = {
      name: "",
      nif: "",
      mobilePhone: "",
      address: "",
      type: "",
      ambit: "",
      currency: "EUR",
      currency_symbol: "€"
    };

    // organization
    organizationPlan = {
      id: "",
      PlatformSubscription: "",
      payment_type: ""
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } as any;

    // suscription
    suscriptionForm = {
      payMethod: "",
      number: ""
    };

    SYMBOLS_CURRENCY: object = { EUR: "€", USD: "$" };
    currencyOptions: object = { EUR: "EUR", USD: "USD" };

    async mounted() {
      const { payment, planId } = this.$route.query;
      if (typeof payment === "string" && typeof planId === "string") {
        const sanitizedPlanId = planId.split(":")[1].trim();
        await this.onSubscriptionSubmit(sanitizedPlanId);
        this.active = "subscription";
      }

      await Promise.all([
        apiOrganizations.getOrganization(this.ongId).then(response => {
          const ong = response.data;
          this.generalForm.name = ong.name;
          this.generalForm.nif = ong.nif;
          this.generalForm.mobilePhone = ong.mobilePhone;
          this.generalForm.type = ong.type;
          this.generalForm.ambit = ong.ambit;
          this.generalForm.address = ong.address;
        }),

        apiOrganizations.getOrganizationPlan(this.ongId).then(({ data }) => {
          this.organizationPlan.id = data?.id;
          this.organizationPlan.PlatformSubscription =
            data?.PlatformSubscription;
          this.organizationPlan.payment_type = data?.payment_type;
        }),

        apiOrganizations.getPlatformConfig(this.ongId).then(({ data }) => {
          this.generalForm.currency = data.platformConfig.currency;
          this.generalForm.currency_symbol =
            data.platformConfig.currency_symbol;
        })
      ]);

      this.loaded = true;
    }

    getSymbolCurrency(value: string): string {
      if (!value) {
        return "€";
      }

      return this.SYMBOLS_CURRENCY[value];
    }

    async onGeneralSubmit() {
      this.generalForm.currency_symbol = this.getSymbolCurrency(
        this.generalForm.currency
      );
      apiOrganizations
        .putOrganization(this.ongId, this.generalForm)
        .then(this.showSuccessNotification)
        .catch(this.showErrorNotification);

      apiOrganizations
        .postCurrencyUpdate(this.ongId, {
          currency: this.generalForm.currency,
          currency_symbol: this.generalForm.currency_symbol
        })
        .then(() => {
          this.showSuccessNotification();
        })
        .catch(this.showErrorNotification);

      return;
    }

    onSubscriptionSubmit(planId: string) {
      return apiOrganizations
        .postOrganizationPlan(this.ongId, {
          platform_subscription_id: planId
          //payment_type: this.organizationPlan.payment_type // todo ?
        })
        .then(this.showSuccessNotification)
        .catch(this.showErrorNotification);
    }

    showSuccessNotification() {
      this.$notify({
        type: "success",
        text: this.$tc("common.notifications.changeSuccess")
      });
    }
    showErrorNotification() {
      this.$notify({
        type: "error",
        text: this.$tc("common.error.generic")
      });
    }

    setSelectedPlan(plan: string) {
      this.organizationPlan.PlatformSubscription.id = plan;
      this.updatePlan(plan);
    }
    setPaymentType(type: string) {
      this.organizationPlan.payment_type = type;
    }

    beforeRouteLeave(_to: any, _from: any, next: any) {
      if (this.blockedBySubscriptionPlan) {
        return false;
      }
      next();
    }

    @Watch("blockedBySubscriptionPlan", { immediate: true })
    onBlockedBySubscriptionPlanChanged(newVal: boolean) {
      if (newVal) {
        this.showBlockedModal = true;
        this.active = "subscription";
      }
    }
  }
